import type { MockTeam } from './types';

export const mockTeam: MockTeam = {
    id: 'team-1',
    name: 'Heaven Due Nuoto',
    code: 'HD2024',
    city: 'Roma',
    province: 'RM',
    region: 'Lazio',
    foundedYear: 1998,
    athletesCount: 42
};

export const mockTeams: MockTeam[] = [
    mockTeam,
    {
        id: 'team-2',
        name: 'Polisportiva Tiburtina',
        code: 'PTB2024',
        city: 'Tivoli',
        province: 'RM',
        region: 'Lazio',
        foundedYear: 1985,
        athletesCount: 67
    },
    {
        id: 'team-3',
        name: 'Aurelia Nuoto',
        code: 'AUR2024',
        city: 'Roma',
        province: 'RM',
        region: 'Lazio',
        foundedYear: 2001,
        athletesCount: 28
    }
];
